import Backdrop from "components/global/Backdrop";
import Button from "components/global/Button";
import ModalWrapper from "components/global/ModalWrapper";
import styled from "styled-components";

const Wrapper = styled(Backdrop)`
  .card {
    background-color: #fff;
    width: 480px;
    border-radius: 16px;
    padding: 48px;
    text-align: center;
  }

  header {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 6px;
  }

  .description,
  a {
    font-size: 14px;
    font-weight: 450px;
    color: var(--body_text);
  }

  a {
    color: var(--secondary);
  }

  .btn-row {
    margin-top: 24px;
    gap: 24px;

    button {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 24px);
      padding: 24px;

      header {
        font-size: 16px;
      }

      .description,
      a {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

const BuyAddonPrompt = ({
  showModal,
  cancelBtnFn,
  actionBtnFn,
  title,
  renderDescription,
  actionBtnText,
}) => {
  return (
    <Wrapper className={`flexRow justifyEnd ${showModal && "show"}`}>
      <ModalWrapper>
        <div className="card">
          <header>{title}</header>
          <p className="description">{renderDescription()}</p>

          <div className="btn-row flexRow alignCenter justifySpaceBetween">
            <Button
              text="Cancel"
              height="48px"
              fullWidth
              className="borderedGrey"
              onClick={cancelBtnFn}
            />
            <Button
              text={actionBtnText || "Continue"}
              height="48px"
              fullWidth
              bg="var(--secondary)"
              onClick={actionBtnFn}
            />
          </div>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};

export default BuyAddonPrompt;
